import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useSyncRapidDataFromWorkflow, useFetchPublicRapidData } from "@rapid/store";
import { useCurrentWorkflow } from "@rapid/hooks/useCurrentWorkflow";
import useApi from "@rapid/hooks/useApi";

/**
 * RapidDataInitializer - Handles automatic sync of rapid data when workflow changes
 *
 * This component should be mounted once in your app (e.g., in App.tsx) to ensure
 * rapid data is synced with the current workflow.
 */
export function RapidDataInitializer() {
    const { currentWorkflow: workflow } = useCurrentWorkflow();
    const syncRapidDataFromWorkflow = useSyncRapidDataFromWorkflow();
    const fetchPublicRapidData = useFetchPublicRapidData();
    const location = useLocation();
    const api = useApi();
    const { shareableSlug } = useParams<{ shareableSlug: string }>();

    const isPublicRoute = location.pathname.includes("/p/");

    const rapidDataId = workflow?.rapidDataId ?? null;

    useEffect(() => {
        if (!rapidDataId) {
            syncRapidDataFromWorkflow(null);
            return;
        }

        if (isPublicRoute) {
            if (workflow?.rapidData?.url === shareableSlug) {
                fetchPublicRapidData(rapidDataId, api);
            }
        } else {
            syncRapidDataFromWorkflow(rapidDataId);
        }
    }, [
        rapidDataId,
        isPublicRoute,
        workflow?.rapidData?.url,
        shareableSlug,
        syncRapidDataFromWorkflow,
        fetchPublicRapidData,
        api
    ]);

    // This component doesn't render anything
    return null;
}
